import React, { useState } from 'react';

import { css, styled } from 'styled-components';

import ContentContainer from 'components/ContentContainer/ContentContainer';
import TabsContent from 'components/ModularBlocks/FlexibleTabbed/components/TabsContent';
import TabsNavigation from 'components/ModularBlocks/FlexibleTabbed/components/TabsNavigation';
import StackHeader from 'components/StackHeader';

import { HeaderType } from 'interfaces/content-stack/contentStack.types';
import { TabI } from 'interfaces/content-stack/modular-blocks/flexibleTabbed';

const Subcopy = styled('p')(
  ({ theme }) => css`
    font-family: ${theme.fonts.default};
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 1.5;
  `
);

export interface FlexibleTabbedProps {
  data: {
    reference: {
      title: string;
      headerType: HeaderType;
      subcopy: string;
      tabs: TabI[];
    }[];
  };
}

const FlexibleTabbed: React.FC<FlexibleTabbedProps> = ({ data }) => {
  const [previousTab, setPreviousTab] = useState<number>(0);
  const [activeTab, setActiveTab] = useState<number>(0);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { tabs, title, subcopy, headerType } = data.reference[0];

  const pushDataLayerEvent = (prevTabLabel: string, newTabLabel: string) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'change_tab',
      event_category: 'change tab',
      event_action: `To: ${newTabLabel}`,
      event_label: `From: ${prevTabLabel}`,
      interaction_type: `To: ${newTabLabel}`,
      interaction_value: `From: ${prevTabLabel}`,
    });
  };

  const toggleTab = (tabIndex: number) => {
    setPreviousTab(activeTab);
    setActiveTab(tabIndex);
    pushDataLayerEvent(tabs[previousTab].tabTitle, tabs[tabIndex].tabTitle);
  };

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  return (
    <ContentContainer>
      <StackHeader headerType={headerType}>{title}</StackHeader>
      <Subcopy>{subcopy}</Subcopy>
      <TabsNavigation
        tabs={tabs}
        activeTab={activeTab}
        toggleTab={toggleTab}
        toggleDropdown={toggleDropdown}
        dropdownOpen={dropdownOpen}
      />
      <TabsContent tabs={tabs} activeTab={activeTab} />
    </ContentContainer>
  );
};

export default FlexibleTabbed;
